import React, {useState, useContext} from "react";
import {arenaLabPage} from "../../../portfolio";
import StyleContext from "../../../contexts/StyleContext";
import "./ArenaLabNews.css";

function ArenaLabNews() {
  const {isDark} = useContext(StyleContext);
  const [showAll, setShowAll] = useState(false);
  
  // Show first 5 news items initially, all when expanded
  const visibleNews = showAll ? arenaLabPage.news : arenaLabPage.news.slice(0, 5);
  const hasMoreNews = arenaLabPage.news.length > 5;
  const hiddenCount = arenaLabPage.news.length - 5;

  return (
    <div className="arena-lab-section news-section" id="lab-news">
      <h2 className="section-title">Latest News</h2>
      <div className="news-list">
        {visibleNews.map((item, index) => {
          if (item.link) {
            return (
              <a
                key={index}
                href={item.link}
                className={`news-list-item ${isDark ? "dark-mode" : ""} news-link`}
                onClick={(e) => {
                  e.preventDefault();
                  const target = document.querySelector(item.link);
                  if (target) {
                    target.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
              >
                <div className="news-badge">{item.date}</div>
                <div className="news-content">
                  <span className="news-text">{item.title}</span>
                  {item.tag && <span className={`news-tag ${item.tag}`}>{item.tag}</span>}
                </div>
              </a>
            );
          }
          
          return (
            <div key={index} className={`news-list-item ${isDark ? "dark-mode" : ""}`}>
              <div className="news-badge">{item.date}</div>
              <div className="news-content">
                <span className="news-text">{item.title}</span>
                {item.tag && <span className={`news-tag ${item.tag}`}>{item.tag}</span>}
              </div>
            </div>
          );
        })}
      </div>
      
      {hasMoreNews && (
        <div className="news-more-container">
          <button 
            className={`news-more-btn ${isDark ? "dark-mode" : ""}`}
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? (
              <>Show Less <span className="arrow-icon">▲</span></>
            ) : (
              <>More News ({hiddenCount} more) <span className="arrow-icon">▼</span></>
            )}
          </button>
        </div>
      )}
    </div>
  );
}

export default ArenaLabNews;
